export default (siteName) => [
    {
        path: 'outsourcing',
        name: 'outsourcing',
        component: () => import('../../components/dashboard/Outsourcing/OutsourcingPage.vue'),
        meta: {
            title: `委外管理${siteName}`,
            activeMenu: 'project',
            activeSubMenu: 'outsourcing',
        },
    },
    {
        path: 'outsourcing/add-company',
        name: 'outsourcing-add-company',
        component: () => import('../../components/dashboard/Outsourcing/OutsourcingEditCompanyPage.vue'),
        meta: {
            title: `新增委外廠商${siteName}`,
            activeMenu: 'project',
            activeSubMenu: 'outsourcing',
        },
    },
    {
        path: 'outsourcing/:sno/edit-company/',
        name: 'outsourcing-edit-company',
        component: () => import('../../components/dashboard/Outsourcing/OutsourcingEditCompanyPage.vue'),
        meta: {
            title: `編輯委外廠商${siteName}`,
            activeMenu: 'project',
            activeSubMenu: 'outsourcing',
        },
    },
    {
        path: 'outsourcing/add-person',
        name: 'outsourcing-add-person',
        component: () => import('../../components/dashboard/Outsourcing/OutsourcingEditPersonPage.vue'),
        meta: {
            title: `新增委外勞務${siteName}`,
            activeMenu: 'project',
            activeSubMenu: 'outsourcing',
        },
    },
    {
        path: 'outsourcing/:sno/edit-person/',
        name: 'outsourcing-edit-person',
        component: () => import('../../components/dashboard/Outsourcing/OutsourcingEditPersonPage.vue'),
        meta: {
            title: `編輯委外勞務${siteName}`,
            activeMenu: 'project',
            activeSubMenu: 'outsourcing',
        },
    },
];
